/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Closingdate1Inputs */

const en_common_closingdate1 = /** @type {(inputs: Common_Closingdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closing Date`)
};

/**
* | output |
* | --- |
* | "Closing Date" |
*
* @param {Common_Closingdate1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_closingdate1 = /** @type {((inputs?: Common_Closingdate1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Closingdate1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_closingdate1(inputs)
});
export { common_closingdate1 as "common_closingDate" }